import { Box, Text, chakra, Flex, Input, Button } from "@chakra-ui/react";
import { ErrorMessage, Field } from "formik";
import { Link } from "react-router-dom";

const StyledInputField = chakra(Field, {
  baseStyle: {
    border: "2px solid",
    borderColor: "gray.200",
    _focus: {
      borderColor: "primary.link",
    },
    fontSize: "14px",
    color: "black.100",
    fontWeight: "400",
    pl: "16px",
    borderRadius: "12px",
    size: "full",
    _dark: {
      backgroundColor: "primary.inverse.gray",
      borderColor: "primary.inverse.gray",
      color: "primary.shineGrayText",
    },
    _light: {
      backgroundColor: "transparent",
    },
  },
});

const StyledCheckboxText = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    color: "primary.grayText",
    fontSize: "14px",
  },
});

const LinkText = chakra(Link, {
  baseStyle: {
    fontWeight: "500",
    color: "gray.neutral",
    fontSize: "16px",
  },
});

// Auth Form Container with Ellipse
export const AuthFormContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    height: "fit-content",
    padding: "44px 26px 26px 26px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "34px",
    borderRadius: "20px",
    // boxShadow:
    //   "0px 0px 0px 1px rgba(0,0,0,0.04), 0px 15px 15px -3px rgba(0,0,0,0.1),0px 4px 6px -4px rgba(0,0,0,0.1)",
    boxShadow: "0px 4px 20px rgba(20, 20, 20, 0.1)",
    border: "4px solid #FFF",
    bg: "#FFFFFF",
    position: "relative",
    overflow: "hidden",
    maxW: "526px",
    w: "100%",
    mx: "auto",
    my: "40px",
  },
});

// Auth Card Ellipse
export const AuthCardEllipse = chakra(Box, {
  baseStyle: {
    width: "474px",
    height: "474px",
    position: "absolute",
    right: "-30px",
    top: "-299px",
    borderRadius: "474px",
    opacity: 0.2,
    bg: "#FFFFFF",
    filter: "blur(77.17774963378906px)",
    pointerEvents: "none",
    zIndex: 0,
  },
});

// Auth Card Top Frame
export const AuthCardTopFrame = chakra(Flex, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    alignSelf: "stretch",
    width: "100%",
  },
});

// KPEC Logo Text
export const KpecLogoText = chakra(Text, {
  baseStyle: {
    color: "#1819B4",
    WebkitTextStrokeWidth: "0.56px",
    WebkitTextStrokeColor: "#1819B4",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    textAlign: "center",
  },
});

// Auth Heading
export const AuthHeading = chakra(Text, {
  baseStyle: {
    color: "#111827",
    textAlign: "center",
    fontSize: "32px",
    fontStyle: "bold",
    fontWeight: 700,
    lineHeight: "normal",
    alignSelf: "stretch",
  },
});

// Auth Subheading
export const AuthSubheading = chakra(Text, {
  baseStyle: {
    color: "#595959",
    textAlign: "center",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    alignSelf: "stretch",
  },
});

// Auth Fields Wrapper
export const AuthFieldsWrapper = chakra(Flex, {
  baseStyle: {
    direction: "column",
    gap: "1.5rem",
    width: "100%",
  },
});

// Auth Input Box
export const AuthInputBox = chakra(Box, {
  baseStyle: {
    height: "40px",
    borderRadius: "8px",
    borderColor: "#CDD6DC",
    background: "#FFF",
    mb: 0,
    width: "100%",
  },
});

// Auth Input Field
export const AuthInputField = chakra(Input, {
  baseStyle: {
    width: "100%",
    bg: "#FFFFFF",
    height: "56px",
    borderRadius: "8px",
    border: "1px solid #BFBFBF", // thin outline
    background: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    _placeholder: {
      color: "#9CA3AF",
    },
    _hover: {
      bg: "#FFFFFF", // keep white on hover
    },
    _focus: {
      bg: "#FFFFFF", // keep white on focus
    },
    _disabled: {
      bg: "#FFFFFF", // keep white even when disabled
    },
  },
});

// Auth Label Text
export const AuthLabelText = chakra(Text, {
  baseStyle: {
    alignSelf: "stretch",
    color: "#2F2F34",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "normal",
  },
});

// Auth Button
export const AuthButton = chakra(Button, {
  baseStyle: {
    display: "flex",
    height: "48px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "16px",
    background: "#1A1A1A",
    color: "#FFF",
    textAlign: "center",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    width: "100%",
    _hover: {
      background: "#33477D",
    },
    _active: {
      background: "#33477D",
    },
  },
});

// Auth Button Wrapper
export const AuthButtonWrapper = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    mt: "1.5rem",
    gap: "10px",
  },
});

// Auth Link Text
export const AuthLinkText = chakra(Text, {
  baseStyle: {
    color: "#1A1A1A",
    textAlign: "right",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "normal",
    cursor: "pointer",
    _hover: {
      textDecoration: "underline",
    },
  },
});

// Auth Checkbox Text
export const AuthCheckboxText = chakra(Text, {
  baseStyle: {
    color: "#2F2F34",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "normal",
  },
});

export const AddNoticeButton = chakra(Button, {
  baseStyle: {
    display: "flex",
    height: "48px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "16px",
    background: "#1819B4",
    color: "#FFF",
    textAlign: "center",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    width: "160px",
    _hover: {
      background: "#1415A0",
    },
    _active: {
      background: "#0F1080",
    },
  },
});

const ForgotPasswordContainer = chakra(Box, {
  baseStyle: {
    width: "full",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    pt: "6px",
    background:
      "linear-gradient(0deg, rgba(167, 187, 200, 0.12) 0%, rgba(167, 187, 200, 0.12) 100%), #FFF",
  },
});

const AllSetContainer = chakra(Box, {
  baseStyle: {
    background: "linear-gradient(180deg, #C2D9EF 0%, #FFFFFF 100%)",
    width: "full",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    pt: "6px",
  },
});
const FooterContainer = chakra(Box, {
  baseStyle: {
    width: "full",
    bg: "white",
    marginTop: "200px",
  },
});

const LogoContainer = chakra(Box, {
  baseStyle: {
    p: 4,
  },
});

const ErrorMessageText = chakra(ErrorMessage, {
  baseStyle: {
    fontWeight: "300",
    fontSize: "14px",
    color: "red",
  },
});

export {
  LinkText,
  StyledCheckboxText,
  StyledInputField,
  ForgotPasswordContainer,
  FooterContainer,
  LogoContainer,
  ErrorMessageText,
  AllSetContainer,
};
